import React, { Component } from 'react'
import shuffle from 'lodash.shuffle'
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import './cards.css'

import { INCREMENT_QUESTION, PROGRESS_USER, INCREMENT_SCORE_USER, UPDATE_ICONS, SHOW_PAGE } from '../actions'
import Timer from './Timer'
import { TIMER_FAILED, TIMER_SUCCESS, TIMER_TICKING } from '../config'

import Explanation from './Explanation'
import Question from './Question'

class Card extends Component {
  state = {
    response: null,
    answered: false,
    height: null
  }

  constructor(props) {
    super(props)
    const { Answer1, Answer2, Answer3 } = props.question

    const mapAnswers = [Answer1, Answer2, Answer3].map((answer, index) => {
      return {
        text: answer,
        index
      }
    })

    this.responses = shuffle(mapAnswers)
    this.resize = this.resize.bind(this)
  }

  componentDidMount() {
    this.setState({
      height: this.buttons.clientHeight
    })

    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    clearTimeout(this.interval)
    window.removeEventListener('resize', this.resize)
  }

  resize = e => {
    this.buttons &&
      this.setState({
        height: this.buttons.clientHeight
      })
  }

  handleClick(value) {
    const { incrementScore, showIcons, updateUserProgress } = this.props
    const { response } = this.state
    if (response != null) {
      return
    }

    if (value === 0) {
      incrementScore()
    }

    updateUserProgress()

    this.setState({
      response: value
    })

    this.interval = setTimeout(() => {
      this.setState({
        answered: true
      })
    }, 2000)

    showIcons(value)
  }

  getTimerColor() {
    const { response } = this.state
    const answered = response != null
    let color = null
    if (answered) {
      color = response === 0 ? TIMER_SUCCESS : TIMER_FAILED
    } else {
      color = TIMER_TICKING
    }
    return color
  }

  onTimeDone = () => {
    const { updateUserProgress, showIcons } = this.props
    updateUserProgress()
    this.setState({
      response: 4
    })

    this.interval = setTimeout(() => {
      this.setState({
        answered: true
      })
    }, 2000)

    showIcons(4)
  }

  nextStep = () => {
    const { nextQuestion, last, updatePage, hideIcons } = this.props
    if (last) {
      updatePage('form')
    } else {
      hideIcons()
      nextQuestion()
    }
  }

  render() {
    const { height, response, answered } = this.state
    const { question, last } = this.props
    const done = response != null
    const cssClass = index => {
      if (response == null) {
        return `btn btn-card btn-base full animated`
      }

      if (response === index && index === 0) {
        return `btn btn-card btn-base full btn-success`
      } else if (response !== index && index === 0) {
        return `btn btn-card btn-base full btn-blink`
      } else if (response === index && index !== 0) {
        return `btn btn-card btn-base full btn-failed`
      } else {
        return `btn btn-card btn-base full`
      }
    }

    return (
      <div className="card">
        <div className="card-inner">
          <Timer done={done} color={this.getTimerColor()} onTimeDone={this.onTimeDone} />
          <ReactCSSTransitionGroup
            transitionName="explanation"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
            component="div"
          >
            {answered === true ? null : (
              <div className={response != null ? `quiz quiz-responded` : `quiz`}>
                <Question height={height} question={question} />
                <ul className="btn-group" ref={r => (this.buttons = r)}>
                  {this.responses.map((resp, index) => {
                    return (
                      <li key={resp.index}>
                        <button
                          className={cssClass(resp.index)}
                          onClick={e => {
                            this.handleClick(resp.index)
                          }}
                          style={{ animationDelay: `${(index + 1) * 0.25}s` }}
                        >
                          {resp.text}
                        </button>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}

            {answered === true ? <Explanation question={question} last={last} nextStep={this.nextStep} /> : null}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    )
  }
}

const mapDispatch = dispatch => {
  return {
    nextQuestion: () => {
      dispatch({
        type: INCREMENT_QUESTION
      })
    },

    updateUserProgress: () => {
      dispatch({
        type: PROGRESS_USER
      })
    },

    incrementScore: () => {
      dispatch({
        type: INCREMENT_SCORE_USER
      })
    },

    showIcons: response => {
      dispatch({
        type: UPDATE_ICONS,
        payload: {
          response,
          answered: true
        }
      })
    },

    hideIcons: () => {
      dispatch({
        type: UPDATE_ICONS,
        payload: {
          response: null,
          answered: false
        }
      })
    },

    updatePage: page => {
      dispatch({
        type: SHOW_PAGE,
        payload: page
      })
    }
  }
}

export default connect(null, mapDispatch)(Card)



// WEBPACK FOOTER //
// ./src/components/Card.js